import * as jsxRuntime from "C:\\Users\\Alejandro\\Source\\Repos\\QuizBowlReader_TS_ReactMobx\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment